// Mobile-first date picker for booking. Renders a horizontal scroll of 14 upcoming days.
import { useMemo } from "react";

const WEEKDAYS = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];
const MONTHS = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];

function fmt(d) {
  // returns YYYY-MM-DD using local time (date-only, no TZ shift)
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function BookingCalendar({ value, onChange, daysAhead = 14, dataTestid = "booking-calendar" }) {
  const days = useMemo(() => {
    const out = [];
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    for (let i = 0; i < daysAhead; i++) {
      const d = new Date(today);
      d.setDate(today.getDate() + i);
      out.push({
        iso: fmt(d),
        weekday: WEEKDAYS[d.getDay()],
        day: d.getDate(),
        month: MONTHS[d.getMonth()],
        isToday: i === 0,
      });
    }
    return out;
  }, [daysAhead]);

  return (
    <div data-testid={dataTestid} className="-mx-1 overflow-x-auto pb-2">
      <div className="flex gap-2 px-1 snap-x snap-mandatory">
        {days.map((d) => {
          const active = value === d.iso;
          return (
            <button
              key={d.iso}
              type="button"
              onClick={() => onChange(d.iso)}
              data-testid={`calendar-day-${d.iso}`}
              className={[
                "snap-start shrink-0 min-w-[68px] rounded-xl border px-3 py-3 text-center transition-all",
                "active:scale-95",
                active
                  ? "bg-[#D4AF37] text-[#0A1128] border-[#D4AF37] shadow-lg shadow-[#D4AF37]/20"
                  : "bg-white text-[#0A1128] border-gray-200 hover:border-[#D4AF37]/60",
              ].join(" ")}
            >
              <div className="text-[10px] uppercase tracking-wider opacity-70">
                {d.isToday ? "Hoje" : d.weekday}
              </div>
              <div className="text-2xl font-bold leading-tight">{d.day}</div>
              <div className="text-[10px] uppercase opacity-70">{d.month}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
